import React from 'react';

import {select} from 'd3-selection';
import ElevationProfile from './ElevationProfile';
import {formatMonth, formatMonthAbbrev} from '../utils/formatters';

class MonthlyTrendProfile extends ElevationProfile {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        import('metrics-graphics').then(({default: MG}) => {
            this.renderGraph(MG);
        });
    }

    renderGraph(MG) {
        const maxX = 11;
        const x_accessor = 'month';
        const y_accessor = 'y';
        const xax_format = formatMonth;
        const xax_count = 12;

        // avoid JS errors, don't render the graph for a non-trail
        if (!this.state.dimensions.width || this.props.months == null) {
            return;
        }
        const graphData = this.props.months.map((units, index) => ({
            month: index,
            [y_accessor]: units,
        }));
        let maxY = -99999;
        for (const month of graphData) {
            if (month[y_accessor] > maxY) {
                maxY = month[y_accessor];
            }
        }
        maxY += 1;

        const graphDict = this.graphInfo(
            graphData,
            maxX,
            maxY,
            x_accessor,
            y_accessor,
            xax_format,
            xax_count,
            'histogram',
            false
        );
        graphDict.mouseover = d => {
            select('svg .mg-active-datapoint')
                .text(
                    `${formatMonthAbbrev(d.x)} ${this.props.yAxisLabel}: ${d.y}`
                );
        };

        MG.data_graphic(graphDict);
    }
}

export default MonthlyTrendProfile;
